import { a as f } from "../add-DH4DZT_w.mjs";
import { f as c } from "../format-DF9p-6BI.mjs";
const l = async (t, o = "series", r, i, s) => {
  const a = /* @__PURE__ */ new Map([
    ["series", `series_prefix__icontains=${t}`],
    ["film", `title_code__iexact=${t}`],
    ["movie", `title_code__iexact=${t}`]
  ]), n = `${r}/${i}?ordering=start_ts_parse&${a.get(o)}&start_date__range=${c(s, "yyyy-MM-dd")},${c(f(s, { days: 14 }), "yyyy-MM-dd")}&limit=20`;
  try {
    const e = await fetch(n);
    if (e != null && e.ok)
      return await e.json();
    console.log(`An error was returned from fetch. HTTP Response Code: ', ${e == null ? void 0 : e.status}`);
  } catch (e) {
    console.log("Fetch failed with error:", e);
  }
}, p = async ({
  programId: t,
  programType: o = "series",
  maxResults: r = 6,
  SCHEDULE_ENDPOINT: i,
  NETWORK: s
}) => {
  const a = /* @__PURE__ */ new Date();
  let e = (await l(t, o, i, s, a)).results.filter((_) => _.start_ts_parse * 1e3 > a.valueOf());
  return e.length > r && (e = e.splice(0, r)), await e;
};
export {
  p as getUpcomingAirDates
};
